import styled, { css } from 'styled-components';
import { COMPACT_WINDOW_MEDIA } from '../../constants';

export const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Poppins', sans-serif;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
`;

export const Content = styled.main`
  width: 100%;
  max-width: ${({ $wide }) => ($wide ? '1200px' : '800px')};
  margin: 0 auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  box-sizing: border-box;

  ${({ $compact }) =>
    $compact &&
    css`
      @media ${COMPACT_WINDOW_MEDIA} {
        max-width: 1200px;
        gap: 12px;
        padding-top: 12px;
        padding-bottom: 12px;
      }
    `}
`;

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const LogoImage = styled.img`
  width: 144px;
  height: auto;

  ${({ $compact }) =>
    $compact &&
    css`
      @media ${COMPACT_WINDOW_MEDIA} {
        width: 104px;
      }
    `}
`;

export const Footer = styled.footer`
  width: 100%;
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  box-sizing: border-box;

  ${({ $compact }) =>
    $compact &&
    css`
      @media ${COMPACT_WINDOW_MEDIA} {
        padding: 4px;
      }
    `}
`;

export const PoweredByText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
`;

export const FooterLogo = styled.img`
  height: 20px;
  width: auto;
`;
